/**
 * English strings for the hovers on the intro's example leads table
 * (PREC-3904). Split out of enOnboardingTourScoring.ts, which is already close
 * to the 500-line cap; spread into `intro.example` there, so keys stay addressed
 * as onboardingTour.scoringStep.intro.example.<...>.
 *
 * These reasons are written for three invented leads — the screen says so above
 * the table. They exist so the hovers the user will actually rely on can be
 * tried out before anything has been scored.
 */
export const enOnboardingTourScoringIntro = {
	dummyNote:
		"These three leads are made up. Hover a grade or a segment to see the reasoning you get on every real lead.",
	hoverHint: "Hover me",
	criteria: {
		hqCountry: "HQ country",
		industry: "Industry",
		employees: "Company size",
		jobTitle: "Job title",
		seniority: "Seniority",
	},
	segmentHover: {
		companyTitle: "Company segment",
		personaTitle: "Persona segment",
		notCategorizedTitle: "Not categorized",
	},
	reasoning: {
		match: {
			overall:
				"Matches your ideal company and your ideal buyer — the finance lead at a company squarely inside your segment. Reach out first.",
			hqCountry: "Berlin is in one of the regions you score highest.",
			industry: "Payments software — one of the industries you sell into.",
			employees: "120 employees sits in the size band you win most often.",
			jobTitle: "CFO is one of the job titles this persona segment is built on.",
			seniority: "C-level: the budget holder, not an influencer.",
			companySegment:
				"Sorted here because the company matches this segment on industry, size and region.",
			personaSegment: "Sorted here because the job title is one this persona segment matches on.",
		},
		partial: {
			overall:
				"The company fits, the person does not: marketing is not one of the roles you sell to. Worth a look if nobody better turns up there.",
			hqCountry: "Hamburg is in one of the regions you score highest.",
			industry: "Logistics — adjacent to your segment rather than inside it.",
			employees: "40 employees is on the small side for your segment.",
			jobTitle: "Marketing Manager is not among the job titles any of your personas match on.",
			seniority: "Mid-level: unlikely to own the budget for this.",
			companySegment:
				"Sorted here because the company matches this segment on industry, size and region.",
			personaSegment:
				"No persona segment matched this job title — the lead still keeps its company segment.",
		},
		miss: {
			overall:
				"Outside your market on every count. Disqualified leads are filtered out quietly so they never cost you time.",
			hqCountry: "Lisbon is outside the regions you target.",
			industry: "Consumer wellness — a market you do not sell into.",
			employees: "3 employees is far below your smallest segment.",
			jobTitle: "Yoga teacher matches none of your personas.",
			seniority: "No seniority signal that maps to a buyer.",
			companySegment: "No company segment matched this company.",
			personaSegment: "No persona segment matched this job title.",
		},
	},
};
